import { useEffect } from 'react'
import { UPLOAD_HISTORY_POLL_MS } from '../constants/uploadHistoryPolling'

/**
 * Silent background refresh while upload history tab is visible.
 * @param {boolean} isHistoryTabActive - e.g. activeTab === 1
 * @param {(opts?: { silent?: boolean }) => Promise<void>} fetchUploadLogs
 */
export function useUploadHistoryPolling(isHistoryTabActive, fetchUploadLogs) {
  useEffect(() => {
    if (!isHistoryTabActive) {
      return undefined
    }
    const id = setInterval(() => {
      fetchUploadLogs({ silent: true })
    }, UPLOAD_HISTORY_POLL_MS)
    return () => clearInterval(id)
  }, [isHistoryTabActive, fetchUploadLogs])
}
